"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var common_1 = require("@angular/common");
var Popover_1 = require("./Popover");
var PopoverContent_1 = require("./PopoverContent");
var core_1 = require("@angular/core");
__export(require("./Popover"));
__export(require("./PopoverContent"));
var PopoverModule = (function () {
    function PopoverModule() {
    }
    return PopoverModule;
}());
PopoverModule = __decorate([
    core_1.NgModule({
        imports: [
            common_1.CommonModule
        ],
        declarations: [
            PopoverContent_1.PopoverContent,
            Popover_1.Popover,
        ],
        exports: [
            PopoverContent_1.PopoverContent,
            Popover_1.Popover,
        ],
        entryComponents: [
            PopoverContent_1.PopoverContent
        ]
    })
], PopoverModule);
exports.PopoverModule = PopoverModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-popover/index.js
// module id = 204
// module chunks = 103